import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, AlertTriangle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); refresh?.(); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("error"); return; }
      } catch { /* retry */ }
      if (++attempts >= 8) { setState("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, refresh]);

  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="payment-success-page">
      {state === "checking" && (
        <>
          <Loader2 className="w-12 h-12 mx-auto text-indigo-400 animate-spin" />
          <h1 className="font-display text-3xl font-bold text-white mt-6">Confirmando pagamento…</h1>
          <p className="text-slate-400 mt-2">Aguarde alguns segundos.</p>
        </>
      )}
      {state === "paid" && (
        <>
          <CheckCircle2 className="w-14 h-14 mx-auto text-teal-400" />
          <h1 className="font-display text-3xl font-bold text-white mt-6" data-testid="payment-success-title">Assinatura ativada!</h1>
          <p className="text-slate-400 mt-2">Seu canal VixVox está ativo no plano Essencial (R$ 299/mês).</p>
          <Button asChild className="mt-8 bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="payment-success-dashboard">
            <Link to="/gestor">Ir para o painel</Link>
          </Button>
        </>
      )}
      {(state === "error" || state === "timeout") && (
        <>
          <AlertTriangle className="w-14 h-14 mx-auto text-amber-400" />
          <h1 className="font-display text-3xl font-bold text-white mt-6">{state === "timeout" ? "Ainda processando" : "Pagamento não confirmado"}</h1>
          <p className="text-slate-400 mt-2">{state === "timeout" ? "A confirmação pode levar alguns minutos. Verifique o painel em instantes." : "Não conseguimos confirmar o pagamento. Tente novamente."}</p>
          <Button asChild variant="outline" className="mt-8 border-slate-700 text-slate-200" data-testid="payment-back-dashboard">
            <Link to="/gestor">Voltar ao painel</Link>
          </Button>
        </>
      )}
    </div>
  );
}
